// extracted by mini-css-extract-plugin
export var fileUpload = "_id-1";
export var modalButton = "_id-0";